<template>

	<div id="ol-map"></div>

</template>


<script>

	import 'ol/ol.css';
	
	import Map from 'ol/Map';
	import View from 'ol/View';

	import TileLayer from 'ol/layer/Tile';
	import VectorLayer from 'ol/layer/Vector';	
	import ImageLayer from 'ol/layer/Image';

	import VectorSource from 'ol/source/Vector';	
	import OSM from 'ol/source/OSM';
	import RasterSource from 'ol/source/Raster';
	
	import Feature from 'ol/Feature';
	import Point from 'ol/geom/Point';
	import Style from 'ol/style/Style';	
	import Icon from 'ol/style/Icon';
	
	
	
	/* baseLayer */
	
	var osmLayer = new TileLayer({
		source: new OSM()
	});
	
	osmLayer.on('postcompose', function (evt) {
		let context = evt.context;
		context.globalCompositeOperation = 'color';
		context.fillStyle = 'rgba(244, 241, 232,0.75)';
		context.fillRect(0, 0, context.canvas.width, context.canvas.height);
		context.globalCompositeOperation = 'source-over';
	});
	
	

	/* locationLayer */

	function locationStyle() {
		return new Style({
			image: new Icon({
				anchor: [0.5, 1],
				src: 'https://www.diwan-el-shark.de/images/icons/marker.png'
			}),
		});
	}

	
   var locationFeature = new Feature({
		geometry: new Point([792520.905757, 6635964.213577]),
	});
	locationFeature.setStyle(locationStyle);

	
	var locationLayer = new VectorLayer({
		source: new VectorSource({
			features: [locationFeature],
		}),
	});	
	
	
	
	export default {

		data: () => ({

			map: null,
			vectorLayers: [locationLayer],
			baseLayer: [osmLayer],
			
			
		}),


		mounted: function() {
				
			this.map = new Map({
				target: 'ol-map',
				layers: this.baseLayer.concat(this.vectorLayers),
				view: new View({
					center: [792520.905757, 6635964.213577], // EPSG:3857
					zoom: 15,
				}),
				loadTilesWhileAnimating: false,
				loadTilesWhileInteracting: true,
			});
		
		},
		
	}
</script>



<style lang="scss">

$color: rgb(240, 240, 240);

#ol-map {
	width: 100%;
	height: 300px;
	background-color: rgb(0, 0, 0);
}

#ol-map canvas.ol-unselectable {
	opacity: 0.8;
}


#ol-map .ol-control button {
	width: 1.7em;
	height: 1.7em;
	background-color: $color;
    background-color: rgba($color, 0.7);
	color: rgb(0,0,0);
}

#ol-map .ol-control button:hover {
    background-color: $color;
}

#ol-map .ol-attribution {
    bottom: 0px;
    right: 0px;
	height: auto;
	background-color: $color;
    background-color: rgba($color, 0.7);
	
	a {
		color: rgb(0,0,0);
	}
}

#ol-map .ol-attribution ul {
	font-family: "Rosarivo", sans-serif;
	text-shadow: none;
}

#ol-map .ol-attribution.ol-uncollapsible img {
	margin-top: 0;
	max-height: 16px;
	vertical-align: bottom;
}

</style>
